import { useCallback, useState } from "react";
import { getAuth, updatePassword as updateUserPassword } from "firebase/auth";
import { firebaseApp } from "../firebase";
import { UpdatePasswordSchema } from "../pages/dashboard/account/content/bottom-view/user-details/update-password/edit-modal/schema";

const useUpdatePassword = () => {
  const auth = getAuth(firebaseApp);
  const [loading, setLoading] = useState<boolean>(false);

  const updatePassword = useCallback(
    async (data: UpdatePasswordSchema) => {
      try {
        const user = auth.currentUser;
        if (!user) {
          throw new Error("User is not authenticated");
        }
        setLoading(true);
        await updateUserPassword(user, data.password);
        return { error: null };
      } catch (e) {
        throw e;
      }
    },
    [auth]
  );

  return { loading, updatePassword };
};

export default useUpdatePassword;
